module.exports = __webpack_public_path__ + "static/assets/06fc7846ba8143bf69c2d1e725e74387.svg";